import { render, staticRenderFns } from "./VSelectBackguard.vue?vue&type=template&id=4f92db21&scoped=true"
import script from "./VSelectBackguard.vue?vue&type=script&lang=js"
export * from "./VSelectBackguard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f92db21",
  null
  
)

export default component.exports